__turbopack_context__.v({
  "pagination": "PlpPagination-module-scss-module__4LI0uq__pagination",
});
